import { http, HttpResponse } from 'msw'
import { UnsecuredJWT } from 'jose'

import { api } from '@/utils/constants'

export const refreshTokens = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.auth.REFRESH_TOKENS}`,
    () => {
        const jwtContent = {
            zer: 'aze',
        }

        const accessToken = new UnsecuredJWT(jwtContent)
            .setIssuedAt()
            .setExpirationTime('1d')
            .encode()

        const refreshToken = new UnsecuredJWT(jwtContent)
            .setIssuedAt()
            .setExpirationTime('15d')
            .encode()

        return HttpResponse.json({
            access: accessToken,
            refresh: refreshToken,
        })
    },
)
